export class PortalRole {
    constructor(json?: any) {
        this.id = json && json.id || null;
        this.roleName = json && json.role_name || null;
        this.roleDescription = json && json.role_description || null;
        this.lastUpdated = json && json.last_updated || null;
        this.inactive = json && json.inactive || false;
    }

    id: number;
    roleName: string;
    roleDescription: string;
    lastUpdated: string;
    inactive: boolean;
}